import React from 'react';
import { getIframeUrl } from '../../../utils';

export const InvoicePreview = ({ externalId }: { externalId?: string }) => {
  const iFrameURL = getIframeUrl(externalId);
  return (
    <div className='m-[24px] h-[calc(100%-278px)] border-[2px] border-bw04 overflow-x-scroll'>
      <iframe data-testid='pdfIframe' className='w-full h-full' title='InvoicePreview' src={`${iFrameURL}&isPreviewMode=true&pdfLayout=true`} />
    </div>
  );
};
